<template>
  <ZigzagServiceLayout
    mainTitle="PRP & Microneedling: Natural Regeneration"
    mainDescription="Our PRP (Platelet-Rich Plasma) therapies use your body’s own growth factors to stimulate natural healing and regeneration with minimal downtime."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'PRPMicroneedlingFacialContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'AESTHETICS',
          title: 'Skin Rejuvenation & Scar Reduction',
          subtitle: 'Stimulates collagen for smoother texture and natural glow.',
          paragraphs: [
            "We harness the power of your body’s natural growth factors to transform your skin.",
            "PRP therapy effectively reduces pigmentation, smooths out acne scars, and rejuvenates overall texture, ensuring a bright and youthful look."
          ],
          list: [
            "Stimulates collagen production",
            "Supports smoother skin texture",
            "Reduces pigmentation and acne scars",
            "Enhances natural radiant glow"
          ],
          image: '/images/services/prp-skin.png'
        },
        {
          label: 'RESTORATION',
          title: 'PRP for Hair Restoration',
          subtitle: 'Strengthens follicles and promotes new growth.',
          paragraphs: [
            "PRP therapy represents a breakthrough in non-surgical hair restoration, effectively tackling hair thinning and loss.",
            "By directly targeting the scalp's follicles with highly concentrated platelets, this treatment reduces shedding and stimulates natural, robust hair growth."
          ],
          list: [
            "Non-surgical hair restoration approach",
            "Strengthens hair follicles at the root",
            "Significantly reduces hair shedding",
            "Promotes natural, thicker hair growth"
          ],
          image: '/images/services/prp-hair.png'
        },
        {
          label: 'WELLNESS & RECOVERY',
          title: 'Joint Relief & Procedure Overview',
          subtitle: 'Natural healing for arthritis, tendinitis, and injury.',
          paragraphs: [
            "PRP is a powerful tool for accelerating your recovery. It significantly reduces inflammation, providing much-needed relief from joint pain, arthritis, and tendinitis.",
            "The procedure is simple: a small blood draw, separation via centrifuge, and precise application. You'll enjoy a quick recovery with minimal downtime."
          ],
          list: [
            "Reduces joint inflammation and pain",
            "Aids arthritis and tendinitis recovery",
            "Simple process: Draw, Separate, Apply",
            "Quick recovery (mild swelling for 24-48h)"
          ],
          image: '/images/services/prp-wellness.png'
        }
      ]
    };
  }
};
</script>
